/*
  Open Air Furniture: live dollar savings for the Bundle & Save builder.
  Custom add-on to the Hyper "Products bundle selection" section. Loaded by a
  Custom Liquid section in templates/page.bundle.json. It does not change the
  theme's own files: it wraps the element's updateBundleBar() and reads the
  tier percentages the section already renders in the bundle box (-5%, -8%...),
  so the tiers stay in sync with the section settings.
  The real discount is applied by Shopify automatic discounts; this only
  shows the shopper what those discounts will take off.
*/
(function () {
  var STYLE_ID = 'oaf-bundle-savings-style';

  function addStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '.oaf-bundle-savings{display:flex;flex-direction:column;gap:4px;font-size:.95em;line-height:1.35}' +
      '.oaf-bundle-savings:empty{display:none}' +
      '.oaf-bundle-savings__save{font-weight:700;color:#0b6b3a}' +
      '.oaf-bundle-savings__next{opacity:.8}' +
      '.oaf-bundle-savings__was{text-decoration:line-through;opacity:.5;font-weight:400;margin-right:.4em;font-size:.8em}';
    document.head.appendChild(s);
  }

  function money(cents) {
    try {
      return window.FoxTheme.Currency.formatMoney(Math.round(cents), window.FoxTheme.settings.moneyFormat);
    } catch (e) {
      return '$' + (Math.round(cents) / 100).toFixed(2);
    }
  }

  function readTiers(el) {
    var tiers = [];
    Array.prototype.forEach.call(el.rawItems || [], function (item, i) {
      var m = (item.textContent || '').match(/-(\d+(?:\.\d+)?)%/);
      if (m) tiers.push({ min: i + 1, pct: parseFloat(m[1]) });
    });
    return tiers.sort(function (a, b) { return a.min - b.min; });
  }

  function init(el) {
    if (el.dataset.oafSavings) return;
    var bar = el.querySelector('.products-bundle-selection__bar');
    var totalRow = bar && bar.querySelector('.products-bundle-selection__bar-total-row');
    var totalEl = bar && bar.querySelector('.products-bundle-selection__bar-total');
    if (!totalRow || !totalEl || typeof el.updateBundleBar !== 'function') return;
    el.dataset.oafSavings = '1';
    addStyle();

    var tiers = readTiers(el);
    var box = document.createElement('div');
    box.className = 'oaf-bundle-savings';
    box.setAttribute('aria-live', 'polite');
    totalRow.insertBefore(box, totalRow.children[1] || null);

    function render() {
      var variants = el.variants || [];
      var count = 0, subtotal = 0;
      variants.forEach(function (v) {
        var q = v.quantity || 1;
        count += q;
        subtotal += (v.price || 0) * q;
      });
      // Match Shopify: each cart line's discount is rounded down to the cent.
      function savedAt(pct) {
        return variants.reduce(function (sum, v) {
          return sum + Math.floor((v.price || 0) * (v.quantity || 1) * pct / 100);
        }, 0);
      }

      var active = null, next = null;
      tiers.forEach(function (t) {
        if (t.min <= count) active = t;
        else if (!next) next = t;
      });

      var html = '';
      if (active && subtotal > 0) {
        var saved = savedAt(active.pct);
        totalEl.innerHTML =
          '<span class="oaf-bundle-savings__was">' + money(subtotal) + '</span>' + money(subtotal - saved);
        html += '<div class="oaf-bundle-savings__save">You save ' + money(saved) + ' (' + active.pct + '% off)</div>';
      }
      if (next && active) {
        var need = next.min - count;
        html += '<div class="oaf-bundle-savings__next">' +
          'Add ' + need + ' more to save ' + next.pct + '%.' +
          '</div>';
      } else if (active) {
        html += '<div class="oaf-bundle-savings__next">You have our best bundle savings.</div>';
      }
      box.innerHTML = html;
    }

    var original = el.updateBundleBar.bind(el);
    el.updateBundleBar = function () {
      original();
      render();
    };
    render();
  }

  function start() {
    document.querySelectorAll('products-bundle-selection').forEach(init);
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('products-bundle-selection').then(start);
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
